import './App.css';
import React from 'react'
import { PropTypes } from 'prop-types'
import { Provider } from 'react-redux'
import { BrowserRouter, Route } from 'react-router-dom'
import Routes from './routes'

const App = ({ store, history }) => (
  <Provider store={store}>
    <BrowserRouter location={history.location} navigator={history}>
      <div>
        <Routes />
      </div>
    </BrowserRouter>
  </Provider>
)

App.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default App;
